import type { IconSvgObject } from './types';

const LineIcon: IconSvgObject = [
  ["path", { d: "M6 8.50391V12.5H7M9 8.5V12.5M11 12.5V8.5L13.5 12.5V8.5M17.5 8.5L15.5 8.50391V10.5051M15.5 10.5051V12.5H17.5M15.5 10.5051H17", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M2.03906 10.6146C2.03906 15.4271 7.05919 19.9581 13.9513 18.8296V21.973C13.9513 21.9815 13.9605 21.9866 13.967 21.9812C14.0924 21.8767 14.9342 21.1731 15.2122 20.8615C17.338 18.4788 21.9054 14.8849 22.0349 10.6146C22.0349 5.80212 17.5846 1.98145 12.0629 1.98145C6.54121 1.98145 2.03906 5.80212 2.03906 10.6146Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default LineIcon;
